import { render } from "./Clients.vue?vue&type=template&id=79585ba2&ts=true"
import script from "./Clients.vue?vue&type=script&lang=ts"
export * from "./Clients.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/javiermartin/OneDrive_Sigeen/Sistena/Server_Mio/sistena-admin-gui-main_rev1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__